import {Button, Dialog, DialogActions, DialogContent, Typography} from "@material-ui/core";
import {useCallback, useContext, useEffect, useRef, useState} from "react";
import {useEventListener} from "../../../../../../../../../Hooks/useEventListener";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";

function convertToString(combKeys) {
    let str = '';
    const addKeys = [
        {key: combKeys.ctrlKey, label: "Control"},
        {key: combKeys.altKey, label: "Alt"},
        {key: combKeys.shiftKey, label: "Shift"},
    ];
    const pressedAddKey = addKeys.findIndex(v => v.key === true);
    if (pressedAddKey !== -1) {
        const addKeyLabel = addKeys[pressedAddKey].label;
        str += addKeyLabel + " + "
        if (combKeys.key !== addKeyLabel) {
            str += combKeys.key
        }
        return str;
    }

    str += combKeys.key

    return str;
}

const ShortcutInput = () => {
    const {
        screenValues,
        onChangeDefaultFields,
        selectedComponent,
    } = useContext(ScreenDesignerContextNew);
    const rootRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState({});
    const [savedString, setSavedString] = useState("");
    const [stringValue, setStringValue] = useState("");
    const currentSelected = findByString(screenValues, selectedComponent.path);

    useEffect(() => {

        if (currentSelected.properties && currentSelected.properties.source) {
            const stringValue = convertToString(currentSelected.properties.source);
            setStringValue(stringValue)
            setSavedString(stringValue)
            setValue(currentSelected.properties.source)
            return;
        }
        setValue({});
        setStringValue("")
        setSavedString("")
    }, [JSON.stringify(currentSelected), selectedComponent.path])

    const keyHandler = useCallback(function keyHandler(e) {
        //..shortcut listener here

        if (!isOpen) return;


        e.stopPropagation();
        e.preventDefault();

        const combKeys = {
            ctrlKey: e.ctrlKey,
            altKey: e.altKey,
            shiftKey: e.shiftKey,
            key: e.key
        }
        const convertedToString = convertToString(combKeys);

        if (convertedToString !== stringValue) {
            setStringValue(convertedToString)
            setValue(combKeys)
        }

    }, [stringValue, isOpen])

    function toggleDialog() {
        setIsOpen(prev => !prev)
    }

    function onApply() {
        onChangeDefaultFields(value, selectedComponent.path + '.' + 'properties.source')
        toggleDialog();
    }

    useEventListener('keydown', keyHandler, window)

    return (
        <>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: "space-between",
                width: '100%',
                paddingLeft: '10px'
            }}>
                <Typography variant={"body2"} color={"initial"} style={{width: '50%'}}>
                    Combination
                </Typography>
                <Button variant={'outlined'} style={{width: '50%'}} onClick={toggleDialog}>
                    <Typography variant={"body2"} color={"textSecondary"}>
                        {savedString || 'enter shortcut...'}
                    </Typography>
                </Button>
            </div>
            <Dialog open={isOpen} onClose={toggleDialog} maxWidth={"xs"} fullWidth={true}>
                <DialogTitle
                    style={{
                        padding: '8px 14px',
                        fontSize: '0.5rem'
                    }}>
                    <Typography variant={"h6"}>Shortcut combination</Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent innerRef={rootRef}>
                    <div style={{padding: 20}}>
                        <Typography variant={"body2"} align={'center'}
                                    color={"textSecondary"}>
                            {stringValue || 'enter shortcut...'}
                        </Typography>
                    </div>
                </DialogContent>
                <Divider/>
                <DialogActions>
                    <Button variant={"contained"} color={'primary'} size={'small'} onClick={onApply}>
                        Apply
                    </Button>
                    <Button variant={"contained"} color={'default'} size={'small'}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ShortcutInput;